import { gql } from "@apollo/client";

export const GET_KETO_BY_ID = gql`
query GetKetoById($idDatosGenerales: Int!) {
    ketosterilRIByDatosGeneralesId(idDatosGenerales: $idDatosGenerales){
        ketosterilRI {
            idKetosterilRI
            idDatosGeneralesRI
            idComboRIValorERCestadio
            laboratorio
            fG
            recuperacionRenalDialisis
            txrenalConDeterioro
            quiereDialisis
            hemodialisisIncremental
        }
        laboratorioAdjunto {
            contentType
            titulo
            archivo
            extension
        }
    }
}
`;